import {Component, Inject, OnDestroy} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Salutation} from '../../../core/user/models/salutation.enum';
import {UserService} from '../../../core/user/services/user.service';
import {AccountService} from '../../../core/account/services/account.rest.service';
import {OwnerModel} from '../../../core/account/owner.model';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-user-data-change',
    templateUrl: './user-data-change.component.html',
    styleUrls: ['./user-data-change.component.scss'],
    standalone: false
})
export class UserDataChangeComponent implements OnDestroy{
  public personalForm = this.formBuilder.group({
      salutation: [''],
      title: [''],
      first_name: [''],
      last_name: ['']
    }
  );
  public salutations = Salutation;
  public ngUnsubscribe$: Subject<void> = new Subject<void>();


  constructor(private formBuilder: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Inject(UserService) public userService: UserService,
              private accountRestService: AccountService,
              protected dialogRef: MatDialogRef<UserDataChangeComponent>) {
    this.personalForm.patchValue(this.data);
  }


  getSalutationValues() {
    return Object.values(this.salutations);
  }

  updateUserData() {
    if (!this.personalForm.valid) {
      return;
    }

    const userData = this.personalForm.value;
    this.accountRestService.changeOwner(userData).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp: any) => {
      if(!resp.error_code) {
        this.dialogRef.close({data: 'success'})
      } else {
        this.dialogRef.close({data: resp.return_object})
      }
    })
  }

  closeDialog(){
    this.dialogRef.close();
  }

  ngOnDestroy(){
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
